export function logBiWithEssentials(biLogger, event, shouldFlushImmediately = false) {
    // https://github.com/wix-private/bi-logger/blob/master/bi-logger-client/lib/bi-logger.js#L42
    const { src, evid, params, ...context } = event;
    const logParams = { src, evid, ...params };
    const logContext = { ...context, category: 'essential' };
    if (shouldFlushImmediately) {
        // @ts-expect-error We are avoiding importing the bi-logger package
        biLogger.log(logParams, logContext);
        return biLogger.flush();
    }
    // @ts-expect-error We are avoiding importing the bi-logger package
    return biLogger.log(logParams, logContext);
}
//# sourceMappingURL=log-bi-with-essential.js.map